import React from'react';
import { Download } from'lucide-react';

/**
 * Export data as CSV download.
 */
function exportCSV(data, filename) {
 if (!data || data.length === 0) return;
 const headers = Object.keys(data[0]);
 const csv = [
 headers.join(','),
 ...data.map((row) =>
 headers.map((h) => {
 const val = row[h];
 const str = val == null ?'' : String(val);
 return str.includes(',') || str.includes('"') || str.includes('\n')
 ?`"${str.replace(/"/g,'""')}"`
 : str;
 }).join(',')
 ),
 ].join('\n');

 const blob = new Blob([csv], { type:'text/csv' });
 const url = URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = url;
 a.download =`${filename}.csv`;
 a.click();
 URL.revokeObjectURL(url);
}

/**
 * Export data as JSON download.
 */
function exportJSON(data, filename) {
 const blob = new Blob([JSON.stringify(data, null, 2)], { type:'application/json' });
 const url = URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = url;
 a.download =`${filename}.json`;
 a.click();
 URL.revokeObjectURL(url);
}

export default function ExportButton({ data, filename ='export', formats = ['csv','json'] }) {
 const [open, setOpen] = React.useState(false);

 if (!data || data.length === 0) return null;

 return (
 <div className="relative">
 <button
 onClick={() => setOpen(!open)}
 className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-600 
 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
 >
 <Download className="w-3.5 h-3.5" />
 Export
 </button>
 {open && (
 <div className="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-10 py-1 min-w-[100px]">
 {formats.includes('csv') && (
 <button
 onClick={() => { exportCSV(data, filename); setOpen(false); }}
 className="block w-full text-left px-3 py-1.5 text-xs hover:bg-gray-50"
 >
 Download CSV
 </button>
 )}
 {formats.includes('json') && (
 <button
 onClick={() => { exportJSON(data, filename); setOpen(false); }}
 className="block w-full text-left px-3 py-1.5 text-xs hover:bg-gray-50"
 >
 Download JSON
 </button>
 )}
 </div>
 )}
 </div>
 );
}
